import Store from "./store";

export { Store };



// WEBPACK FOOTER //
// ./src/redux/index.js